<template>
  <div id="simple-calendar-app">
    <div class="vx-card no-scroll-content">
      <calendar-view
        ref="calendar"
        :displayPeriodUom="calendarView"
        :show-date="showDate"
        :events="simpleCalendarEvents"
        locale="ko"
        enableDragDrop
        :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
        eventBorderHeight="0px"
        eventContentHeight="1.65rem"
        class="theme-default"
        @click-date="openAddNewEvent"
        @click-event="openEditEvent"
        @drop-on-date="eventDragged">
        <div slot="header" class="mb-4">
          <div class="vx-row no-gutter">
            <!-- Month Name -->
            <div class="vx-col w-1/3 items-center sm:flex hidden">
              <!-- Add new event button -->
              <vs-button icon-pack="feather" icon="icon-plus" @click="promptAddNewEvent(new Date())">일정추가</vs-button>
            </div>

            <!-- Current Month -->
            <div class="vx-col sm:w-1/3 w-full sm:my-0 my-3 flex sm:justify-end justify-center order-last">
              <div class="flex items-center">
                <feather-icon
                  :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                  @click="updateMonth(-1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />

                <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ monthDate}}</span>

                <feather-icon
                  :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                  @click="updateMonth(1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />
              </div>
            </div>

            <div class="vx-col sm:w-1/3 w-full flex justify-center">
              <template v-for="(view, index) in calendarViewTypes">
                <vs-button
                  v-if="calendarView === view.val"
                  :key="String(view.val) + 'filled'"
                  type="filled"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ view.label }}</vs-button>
                <vs-button
                  v-else
                  :key="String(view.val) + 'border'"
                  type="border"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ view.label }}</vs-button>
              </template>

            </div>
          </div>

          <div class="vx-row sm:flex hidden mt-4">
            <div class="vx-col w-full flex">
              <!-- Labels -->
              <div class="flex flex-wrap sm:justify-start justify-center">
                  <div v-for="(label, index) in calendarLabels" :key="index" class="flex items-center mr-4 mb-2">
                      <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                      <span>{{ label.text }}</span>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </calendar-view>
    </div>

    <!-- ADD EVENT -->
    <vs-prompt
        class="calendar-event-dialog"
        title="일정 추가"
        accept-text= "추가"
        cancel-text="취소"
        @accept="addEvent"
        :active.sync="activePromptAddEvent">
        <div class="calendar__label-container flex">
          <vs-chip style="margin-bottom:10px;" v-if="labelLocal != 'none'" class="text-white" :class="'bg-' + labelColor(labelLocal)">{{ labelLocal }}</vs-chip>
          <vs-dropdown vs-custom-content vs-trigger-click class="ml-auto my-2 cursor-pointer">
            <feather-icon icon="TagIcon" svgClasses="h-5 w-5" class="cursor-pointer" @click.prevent></feather-icon>
            <vs-dropdown-menu style="z-index: 200001">
              <vs-dropdown-item v-for="(label, index) in calendarLabels" :key="index" @click="labelLocal = label.value">
                <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                <span>{{ label.text }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <vs-input name="event-name" v-validate="'required'" class="w-full" label-placeholder="제목" v-model="task.title"></vs-input>
        <div class="my-4">
            <small class="date-label">시작</small>
            <datepicker :language="$vs.rtl ? langHe : langEn" name="start-date" v-model="task.startDate" format="yyyy월 MMM dd일" :disabled="disabledFrom"></datepicker>
        </div>
        <div class="my-4">
            <small class="date-label">종료</small>
            <datepicker :language="$vs.rtl ? langHe : langEn" :disabledDates="disabledDatesTo" name="end-date"  format="yyyy년 MMM dd일" v-model="task.endDate"></datepicker>
        </div>
        <div>
          <small class="date-label">설명</small>
          <vs-textarea counter="500" label-placeholder="설명" v-model="task.detail"/>
        </div>
        <!-- <vs-input name="event-url" v-validate="'url'" class="w-full mt-6" label-placeholder="Event URL" v-model="url" :color="!errors.has('event-url') ? 'success' : 'danger'"></vs-input> -->

    </vs-prompt>

    <!-- EDIT EVENT -->
    <vs-prompt
        class="calendar-event-dialog"
        title="일정 수정"
        accept-text= "완료"
        cancel-text = "삭제"
        button-cancel = "border"
        @cancel="removeEvent"
        @accept="editEvent"
        :active.sync="activePromptEditEvent">
        <div class="calendar__label-container flex">
            <vs-chip style="margin-bottom:10px;" v-if="labelLocal != 'none'" class="text-white" :class="'bg-' + labelColor(labelLocal)">{{ labelLocal }}</vs-chip>
            <vs-dropdown vs-custom-content class="ml-auto my-2 cursor-pointer">
                <feather-icon icon="TagIcon" svgClasses="h-5 w-5" @click.prevent></feather-icon>
                <vs-dropdown-menu style="z-index: 200001">
                        <vs-dropdown-item v-for="(label, index) in calendarLabels" :key="index" @click="labelLocal = label.value">
                            <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                            <span>{{ label.text }}</span>
                        </vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>
        </div>

        <vs-input name="event-name" v-validate="'required'" class="w-full" label-placeholder="제목" v-model="task.title"></vs-input>
        <div class="my-4">
            <small class="date-label">시작</small>
            <datepicker :language="$vs.rtl ? langHe : langEn" :disabledDates="disabledDatesFrom" name="start-date"  format="yyyy년 MMM dd일" v-model="task.startDate"></datepicker>
        </div>
        <div class="my-4">
            <small class="date-label">종료</small>
            <datepicker :language="$vs.rtl ? langHe : langEn" :disabledDates="disabledDatesTo" name="end-date"  format="yyyy년 MMM dd일" v-model="task.endDate"></datepicker>
        </div>
        <div>
          <small class="date-label">설명</small>
          <vs-textarea counter="500" label-placeholder="설명" v-model="task.detail"/>
        </div>
        <!-- <vs-input name="event-url" v-validate="'url'" class="w-full mt-6" label-placeholder="Event URL" v-model="url" :color="!errors.has('event-url') ? 'success' : 'danger'"></vs-input> -->

    </vs-prompt>
  </div>
</template>

<script>
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"
import moduleCalendar from '@/store/calendar/moduleCalendar.js'
require("vue-simple-calendar/static/css/default.css")

import Datepicker from 'vuejs-datepicker'
import { ko, he } from "vuejs-datepicker/src/locale"

export default {
  components: {
    CalendarView,
    CalendarViewHeader,
    Datepicker,
    moduleCalendar
  },
  data() {
    return {
      showDate: new Date(),
      monthDate:null,
      disabledFrom: false,
      labelLocal: 'none',
      task:{
        id:0,
        title:'',
        startDate:'',
        endDate:'',
        tag:'none',
        detail:'',
        link:''
      },
      langHe: he,
      langEn: ko,

      url: '',
      calendarView: 'month',
      // calendarLabels: [{color:'none', text:none}],

      activePromptAddEvent: false,
      activePromptEditEvent: false,

      calendarViewTypes: [
        {
          label: "월",
          val: "month"
        },
        {
          label: "주",
          val: "week"
        },
      ]
    }
  },
  computed: {
    simpleCalendarEvents() {
        return this.$store.state.calendar.events
    },
    validForm() {
        return this.task.title != '' && this.task.start_time != '' && this.task.end_time != '' && (Date.parse(this.task.end_time) - Date.parse(this.task.start_time)) >= 0
    },
    disabledDatesTo() {
        return { to: new Date(this.task.start_time) }
    },
    disabledDatesFrom() {
        return { from: new Date(this.task.end_time) }
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    calendarLabels() {
        return this.$store.state.calendar.eventLabels
    },
    labelColor() {
      return (label) => {
        if (label == "개인") return "primary"
        if (label == "결과물") return "warning"
        // if (label == "personal") return "danger"
        if (label == "none") return "success"
      }
    },
    windowWidth() {
      return this.$store.state.windowWidth
    }
  },
  methods: {
    addEvent() {
      const obj = {title: this.task.title, start_time: this.task.startDate, end_time: this.task.endDate, tag: this.labelLocal, link: this.task.link, detail:this.task.detail, color:this.labelColor(this.labelLocal)}
      this.$store.dispatch('calendar/addEvent', obj)
    },
    updateMonth(val) {
      this.monthDate = this.$moment(this.$refs.calendar.getIncrementedPeriod(val)).format('YYYY MM월')
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val);
    },
    clearFields() {
      this.task.id = 0
      this.task.title = ''
      this.task.startDate = ''
      this.task.endDate = ''
      this.task.tag = 'none'
      this.labelLocal = 'none'
      this.task.detail = ''
    },
    promptAddNewEvent(date) {
      this.disabledFrom = false
      this.addNewEventDialog(date);
    },
    addNewEventDialog(date) {
      this.clearFields();
      this.task.startDate = date;
      this.task.endDate = date;
      this.activePromptAddEvent = true;
    },
    openAddNewEvent(date) {
      this.disabledFrom = true;
      this.addNewEventDialog(date);
    },
    openEditEvent(event) {
      const e = this.$store.getters['calendar/getEvent'](event.id)
      this.labelLocal = e.tag
      this.task.id = e.id
      this.task.title = e.title
      this.task.startDate = e.start_time
      this.task.endDate = e.end_time
      this.task.link = e.link
      this.task.tag = e.tag
      this.task.detail = e.detail
      this.activePromptEditEvent = true;
    },
    editEvent() {
      const obj = {id: this.task.id, title: this.task.title, start_time: this.task.startDate, end_time: this.task.endDate, tag: this.labelLocal, link: this.task.link, detail:this.task.detail, color:this.labelColor(this.labelLocal)}
      this.$store.dispatch('calendar/editEvent', obj)
    },
    removeEvent() {
      this.$store.dispatch('calendar/removeEvent', this.task.id)
    },
    eventDragged(event, date) {
      // const obj = event.originalEvent
      // console.log(event.originalEvent.id)
      // const e = this.$store.getters['calendar/getEvent'](event.originalEvent.id)
      var startDay = this.$moment(this.$moment(event.originalEvent.start_time).format('YYYY-MM-DD'))
      var newDay = this.$moment(this.$moment(date).format('YYYY-MM-DD'))
      var day = startDay.diff(newDay, 'days')
      var endTime = this.$moment(event.originalEvent.endDate).add(day*-1, 'days').format('YYYY-MM-DD')
      const obj = {id: event.originalEvent.id, title: event.originalEvent.title, start_time: date, end_time: endTime, tag: event.originalEvent.tag,
        link: event.originalEvent.link, detail:event.originalEvent.detail, color:this.labelColor(event.originalEvent.tag)}
      this.$store.dispatch('calendar/editEvent', obj)
    }
  },
  // mounted(){
  //     console.log(this.$refs.calendar)
  //     console.log(this.$refs.calendar.monthNameFormat)
  //     console.log(this.$refs.calendar.monthNames)
  // },
  created() {
    // String languageToLoad  = "fa"; // your language


    // this.showDate = this.$moment(new Date()).format('YYYYMMDD')
    // console.log()
    // this.showDate =
    this.monthDate = this.$moment(new Date()).format('YYYY MM월')
    this.$store.registerModule('calendar', moduleCalendar)
    this.$store.dispatch("calendar/getEvent", this.activeUserInfo.uid)
    // this.$store.dispatch("calendar/fetchEvents")

  },
  beforeDestroy() {
    this.$store.unregisterModule('calendar')
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>
